import { PROGRAM_PROFILES } from "../data/programProfiles";
import "../styles/results-report.css";

export default function ResultsReport({
  profile,
  personalityData,
  personalityBlend,
  secondaryProfile,
  topRecommendation,
  behaviorNarrative,
  topProgramProfile,
  programmeInfo
}) {

  return (
    <div className="report-document">

      {/* HEADER */}
      <div className="report-header">
        <h1>Personality Assessment Report</h1>

        <p>
          Personalized program recommendations based on
          your assessment results.
        </p>
      </div>

      {/* PERSONALITY SUMMARY */}
      <section className="report-section">

        <h2>{profile.title}</h2>

        <p>{profile.shortSummary}</p>

        {personalityBlend && secondaryProfile && (
          <div className="personality-blend">
            <span className="personality-blend-label">
              Your personality blend
            </span>

            <p className="personality-blend-title">
              Primarily {profile.title}, with{" "}
              {secondaryProfile.title} tendencies
            </p>

            <p className="personality-blend-summary">
              {
                personalityBlend.relationship
                  ?.blendSummary
              }
            </p>
          </div>
        )}

        <div className="report-insights">

          {personalityData.insights?.map((insight, index) => (
            <div
              key={index}
              className="report-insight-item"
            >
              • {insight}
            </div>
          ))}

        </div>

      </section>

      {/* TOP RECOMMENDATION */}
      <section className="report-section">

        <h2>Top Recommendation</h2>

        <div className="report-program-card">

          <div className="report-program-header">

            <h3>
              {topRecommendation.program}
            </h3>

            <span>
              {topRecommendation.percentage}%
            </span>

          </div>

          <p>{behaviorNarrative}</p>

        </div>

      </section>

      {/* FIT BREAKDOWN */}
      <section className="report-section">

        <h2>Fit Breakdown</h2>

        {Object.entries(
            topProgramProfile?.fitDimensions || {}
          ).map(([key, value]) => (

            <div
            key={key}
            className="report-fit-row"
            >

            <div className="report-fit-header">

                <span className="report-fit-label">
                {key
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) =>
                    str.toUpperCase()
                    )}
                </span>

                <span className="report-fit-score">
                {value}%
                </span>

            </div>

            <div className="report-fit-bar">

                <div
                className={`report-fit-fill ${
                    value >= 80
                    ? "high"
                    : value >= 60
                    ? "moderate"
                    : "low"
                }`}
                style={{
                    width: `${value}%`
                }}
                />

            </div>

            </div>

        ))}

        </section>

      {/* CAREER PATHS */}
      <section className="report-section">

        <h2>Career Paths</h2>

        <div className="report-tags">

          {programmeInfo.careerPathways?.map((career, index) => (

            <span
              key={index}
              className="report-tag"
            >
              {career}
            </span>

          ))}

        </div>

      </section>

      {/* REALITY CHECK */}
      <section className="report-section">

        <h2>Program Reality Check</h2>

        <div className="report-grid">

          <div>
            <h4>Workload</h4>

            <p>
              {
                PROGRAM_PROFILES[
                  topRecommendation.program
                ]?.realityCheck?.workload
              }
            </p>
          </div>

          <div>
            <h4>Environment</h4>

            <p>
              {
                PROGRAM_PROFILES[
                  topRecommendation.program
                ]?.realityCheck?.environment
              }
            </p>
          </div>

          <div>
            <h4>Pressure Level</h4>

            <p>
              {
                PROGRAM_PROFILES[
                  topRecommendation.program
                ]?.realityCheck?.pressureLevel
              }
            </p>
          </div>

          <div>
            <h4>Main Challenge</h4>

            <p>
              {
                PROGRAM_PROFILES[
                  topRecommendation.program
                ]?.realityCheck?.keyChallenge
              }
            </p>
          </div>

        </div>

      </section>

      {/* SKILLS */}
        <section className="report-section">

        <h2>Skills To Strengthen</h2>

        <div className="report-tags">

            {topProgramProfile?.skillsToStrengthen?.map(
            (skill, index) => (

            <span
                key={index}
                className="report-tag"
            >
                {skill}
            </span>

            ))}

        </div>

        </section>

    </div>
  );
}
